export default __webpack_public_path__ + "static/media/ar_app_login.cbf5ba3c.png";